export const currency = [
  { label: "AED - United Arab Emirates Dirham (د.إ)", value: "aed" },
  { label: "AFN - Afghan Afghani (؋)", value: "afn" },
  { label: "ALL - Albanian Lek (Lek)", value: "all" },
  { label: "AMD - Armenian Dram (֏)", value: "amd" },
  { label: "ANG - Netherlands Antillean Guilder (ƒ)", value: "ang" },
  { label: "AOA - Angolan Kwanza (Kz)", value: "aoa" },
  { label: "ARS - Argentine Peso ($)", value: "ars" },
  { label: "AUD - Australian Dollar ($)", value: "aud" },
  { label: "AWG - Aruban Florin (ƒ)", value: "awg" },
  { label: "AZN - Azerbaijani Manat (₼)", value: "azn" },
  { label: "BAM - Bosnia-Herzegovina Convertible Mark (KM)", value: "bam" },
  { label: "BBD - Barbadian Dollar ($)", value: "bbd" },
  { label: "BDT - Bangladeshi Taka (৳)", value: "bdt" },
  { label: "BGN - Bulgarian Lev (лв)", value: "bgn" },
  { label: "BHD - Bahraini Dinar (ب.د)", value: "bhd" },
  { label: "BIF - Burundian Franc (FBu)", value: "bif" },
  { label: "BMD - Bermudian Dollar ($)", value: "bmd" },
  { label: "BND - Brunei Dollar ($)", value: "bnd" },
  { label: "BOB - Bolivian Boliviano (Bs.)", value: "bob" },
  { label: "BRL - Brazilian Real (R$)", value: "brl" },
  { label: "BSD - Bahamian Dollar ($)", value: "bsd" },
  { label: "BTN - Bhutanese Ngultrum (Nu.)", value: "btn" },
  { label: "BWP - Botswanan Pula (P)", value: "bwp" },
  { label: "BYN - Belarusian Ruble (Br)", value: "byn" },
  { label: "BZD - Belize Dollar (BZ$)", value: "bzd" },
  { label: "CAD - Canadian Dollar ($)", value: "cad" },
  { label: "CDF - Congolese Franc (FC)", value: "cdf" },
  { label: "CHF - Swiss Franc (Fr.)", value: "chf" },
  { label: "CLP - Chilean Peso ($)", value: "clp" },
  { label: "CNY - Chinese Yuan (¥)", value: "cny" },
  { label: "COP - Colombian Peso ($)", value: "cop" },
  { label: "CRC - Costa Rican Colón (₡)", value: "crc" },
  { label: "CUP - Cuban Peso (₱)", value: "cup" },
  { label: "CVE - Cape Verdean Escudo (Esc)", value: "cve" },
  { label: "CZK - Czech Republic Koruna (Kč)", value: "czk" },
  { label: "DJF - Djiboutian Franc (Fdj)", value: "djf" },
  { label: "DKK - Danish Krone (kr)", value: "dkk" },
  { label: "DOP - Dominican Peso (RD$)", value: "dop" },
  { label: "DZD - Algerian Dinar (د.ج)", value: "dzd" },
  { label: "EGP - Egyptian Pound (£)", value: "egp" },
  { label: "ERN - Eritrean Nakfa (Nfk)", value: "ern" },
  { label: "ETB - Ethiopian Birr (Br)", value: "etb" },
  { label: "EUR - Euro (€)", value: "eur" },
  { label: "FJD - Fijian Dollar ($)", value: "fjd" },
  { label: "FKP - Falkland Islands Pound (£)", value: "fkp" },
  { label: "GBP - British Pound Sterling (£)", value: "gbp" },
  { label: "GEL - Georgian Lari (₾)", value: "gel" },
  { label: "GGP - Guernsey Pound (£)", value: "ggp" },
  { label: "GHS - Ghanaian Cedi (₵)", value: "ghs" },
  { label: "GIP - Gibraltar Pound (£)", value: "gip" },
  { label: "GMD - Gambian Dalasi (D)", value: "gmd" },
  { label: "GNF - Guinean Franc (FG)", value: "gnf" },
  { label: "GTQ - Guatemalan Quetzal (Q)", value: "gtq" },
  { label: "GYD - Guyanaese Dollar ($)", value: "gyd" },
  { label: "HKD - Hong Kong Dollar (HK$)", value: "hkd" },
  { label: "HNL - Honduran Lempira (L)", value: "hnl" },
  { label: "HRK - Croatian Kuna (kn)", value: "hrk" },
  { label: "HTG - Haitian Gourde (G)", value: "htg" },
  { label: "HUF - Hungarian Forint (Ft)", value: "huf" },
  { label: "IDR - Indonesian Rupiah (Rp)", value: "idr" },
  { label: "ILS - Israeli New Sheqel (₪)", value: "ils" },
  { label: "IMP - Isle of Man Pound (£)", value: "imp" },
  { label: "INR - Indian Rupee (₹)", value: "inr" },
  { label: "IQD - Iraqi Dinar (د.ع)", value: "iqd" },
  { label: "IRR - Iranian Rial (﷼)", value: "irr" },
  { label: "ISK - Icelandic Króna (kr)", value: "isk" },
  { label: "JEP - Jersey Pound (£)", value: "jep" },
  { label: "JMD - Jamaican Dollar (J$)", value: "jmd" },
  { label: "JOD - Jordanian Dinar (د.ا)", value: "jod" },
  { label: "JPY - Japanese Yen (¥)", value: "jpy" },
  { label: "KES - Kenyan Shilling (KSh)", value: "kes" },
  { label: "KGS - Kyrgystani Som (сом)", value: "kgs" },
  { label: "KHR - Cambodian Riel (៛)", value: "khr" },
  { label: "KMF - Comorian Franc (CF)", value: "kmf" },
  { label: "KRW - South Korean Won (₩)", value: "krw" },
  { label: "KWD - Kuwaiti Dinar (د.ك)", value: "kwd" },
  { label: "KYD - Cayman Islands Dollar ($)", value: "kyd" },
  { label: "KZT - Kazakhstani Tenge (₸)", value: "kzt" },
  { label: "LAK - Laotian Kip (₭)", value: "lak" },
  { label: "LBP - Lebanese Pound (£)", value: "lbp" },
  { label: "LKR - Sri Lankan Rupee (₨)", value: "lkr" },
  { label: "LRD - Liberian Dollar ($)", value: "lrd" },
  { label: "LSL - Lesotho Loti (L)", value: "lsl" },
  { label: "LYD - Libyan Dinar (ل.د)", value: "lyd" },
  { label: "MAD - Moroccan Dirham (د.م.)", value: "mad" },
  { label: "MDL - Moldovan Leu (L)", value: "mdl" },
  { label: "MGA - Malagasy Ariary (Ar)", value: "mga" },
  { label: "MKD - Macedonian Denar (ден)", value: "mkd" },
  { label: "MMK - Myanma Kyat (Ks)", value: "mmk" },
  { label: "MNT - Mongolian Tugrik (₮)", value: "mnt" },
  { label: "MOP - Macanese Pataca (MOP$)", value: "mop" },
  { label: "MUR - Mauritian Rupee (₨)", value: "mur" },
  { label: "MVR - Maldivian Rufiyaa (Rf)", value: "mvr" },
  { label: "MWK - Malawian Kwacha (MK)", value: "mwk" },
  { label: "MXN - Mexican Peso ($)", value: "mxn" },
  { label: "MYR - Malaysian Ringgit (RM)", value: "myr" },
  { label: "MZN - Mozambican Metical (MT)", value: "mzn" },
  { label: "NAD - Namibian Dollar (N$)", value: "nad" },
  { label: "NGN - Nigerian Naira (₦)", value: "ngn" },
  { label: "NIO - Nicaraguan Córdoba (C$)", value: "nio" },
  { label: "NOK - Norwegian Krone (kr)", value: "nok" },
  { label: "NPR - Nepalese Rupee (₨)", value: "npr" },
  { label: "NZD - New Zealand Dollar ($)", value: "nzd" },
  { label: "OMR - Omani Rial (ر.ع.)", value: "omr" },
  { label: "PAB - Panamanian Balboa (B/.)", value: "pab" },
  { label: "PEN - Peruvian Nuevo Sol (S/.)", value: "pen" },
  { label: "PGK - Papua New Guinean Kina (K)", value: "pgk" },
  { label: "PHP - Philippine Peso (₱)", value: "php" },
  { label: "PKR - Pakistani Rupee (₨)", value: "pkr" },
  { label: "PLN - Polish Zloty (zł)", value: "pln" },
  { label: "PYG - Paraguayan Guarani (₲)", value: "pyg" },
  { label: "QAR - Qatari Rial (ر.ق)", value: "qar" },
  { label: "RON - Romanian Leu (lei)", value: "ron" },
  { label: "RSD - Serbian Dinar (дин.)", value: "rsd" },
  { label: "RUB - Russian Ruble (₽)", value: "rub" },
  { label: "RWF - Rwandan Franc (FRw)", value: "rwf" },
  { label: "SAR - Saudi Riyal (ر.س)", value: "sar" },
  { label: "SBD - Solomon Islands Dollar (SI$)", value: "sbd" },
  { label: "SCR - Seychellois Rupee (₨)", value: "scr" },
  { label: "SEK - Swedish Krona (kr)", value: "sek" },
  { label: "SGD - Singapore Dollar ($)", value: "sgd" },
  { label: "SHP - Saint Helena Pound (£)", value: "shp" },
  { label: "SLE - Sierra Leonean Leone (Le)", value: "sle" },
  { label: "SOS - Somali Shilling (Sh.So.)", value: "sos" },
  { label: "SRD - Surinamese Dollar (SRD$)", value: "srd" },
  { label: "SYP - Syrian Pound (£S)", value: "syp" },
  { label: "SZL - Swazi Lilangeni (L)", value: "szl" },
  { label: "THB - Thai Baht (฿)", value: "thb" },
  { label: "TJS - Tajikistani Somoni (ЅМ)", value: "tjs" },
  { label: "TMT - Turkmenistani Manat (T)", value: "tmt" },
  { label: "TND - Tunisian Dinar (د.ت)", value: "tnd" },
  { label: "TOP - Tongan Pa'anga (T$)", value: "top" },
  { label: "TRY - Turkish Lira (₺)", value: "try" },
  { label: "TTD - Trinidad and Tobago Dollar (TT$)", value: "ttd" },
  { label: "TWD - New Taiwan Dollar (NT$)", value: "twd" },
  { label: "TZS - Tanzanian Shilling (TSh)", value: "tzs" },
  { label: "UAH - Ukrainian Hryvnia (₴)", value: "uah" },
  { label: "UGX - Ugandan Shilling (USh)", value: "ugx" },
  { label: "USD - United States Dollar ($)", value: "usd" },
  { label: "UYU - Uruguayan Peso ($U)", value: "uyu" },
  { label: "UZS - Uzbekistan Som (so'm)", value: "uzs" },
  { label: "VND - Vietnamese Dong (₫)", value: "vnd" },
  { label: "VUV - Vanuatu Vatu (VT)", value: "vuv" },
  { label: "WST - Samoan Tala (WS$)", value: "wst" },
  { label: "XAF - Central African CFA Franc (FCFA)", value: "xaf" },
  { label: "XCD - East Caribbean Dollar (EC$)", value: "xcd" },
  { label: "XOF - West African CFA Franc (CFA)", value: "xof" },
  { label: "XPF - CFP Franc (₣)", value: "xpf" },
  { label: "YER - Yemeni Rial (﷼)", value: "yer" },
  { label: "ZAR - South African Rand (R)", value: "zar" },
  { label: "ZMW - Zambian Kwacha (ZK)", value: "zmw" },
];
